import styled from 'styled-components';
import { ButtonWrapper } from 'components/molecules/views/components';

export const SUAttachmentWrapper = styled.div`
  .ant-collapse-item .ant-collapse-header {
    padding: 0 var(--spacing-05);
  }
  .ant-collapse-content {
    padding: 0 var(--spacing-05) var(--spacing-03);
  }
  .ant-collapse-item {
    padding-bottom: var(--spacing-03);
  }
`;
export const StyledButtonWrapper = styled(ButtonWrapper)`
  margin-left: var(--spacing-03);
  margin-right: var(--spacing-03);
  &:hover svg,
  &:focus svg {
    color: var(--gray-100);
  }
`;
